import './Footer.scss';

export default function Footer() {
  return <div className='footer'> 
    <div>© {new Date().getFullYear()} StoneX Group Inc. All Rights Reserved.</div> 
    <div><a href='https://www.stonex.com/en/privacy-notice/' target='_blank'>Privacy Policy</a></div>  
    <div><a href='https://www.stonex.com/en/terms-and-conditions/' target='_blank'>Terms of Use</a></div>  
    <div><a href='http://www.stonex.com/' target='_blank'>StoneX.com</a></div>  
  </div>
}